/**
* @file 文章内容
* @author Ice(chenzhouji@baidu.com)
*/
import React, {FunctionComponent, useEffect, useCallback, useState} from 'react';
import axios from 'axios';

type PostBodyProps = {
    title: string
    date: string
    content: string
    lang: string
    downloadHref?: string
};

const __ = (key: string, lang: string) => {
    const l = lang || 'zh';
    const dict: any = {
        'Last Updated': {
            en: 'Last Updated',
            zh: '更新时间'
        },
        'Download': {
            en: 'Download',
            zh: '下载文档'
        }
    };

    return dict[key][l];
};

const PostBody: FunctionComponent<PostBodyProps> = ({
    title,
    date,
    content,
    lang,
    downloadHref
}) => {
    const [pdfButtonAllowed, setPdfButtonAllowed] = useState(false);
    const checkPdf = useCallback(() => {
        downloadHref && axios.head(downloadHref)
            .then(() => setPdfButtonAllowed(true))
            .catch(() => setPdfButtonAllowed(false));
    }, [downloadHref, setPdfButtonAllowed]);

    useEffect(() => {
        checkPdf();
    }, [checkPdf]);

    const trackClick = useCallback(() => {
        // 忽略时间信息
        const href: string = downloadHref || '';
        const link: string = href && href.split('?t=')[0];
        window._hmt && window._hmt.push(['_trackEvent', 'pdfDownload', 'click', link]);
    }, []);

    return (
        <div className="post">
            <h1 className="post__title">{title}</h1>
            <div className="post__description">
                <div className="post__date">{__('Last Updated', lang)}：{date}</div>
                {pdfButtonAllowed
                    ? <div className="post__download">
                        <a
                            href={downloadHref}
                            target="_blank"
                            onClick={trackClick}
                        >{__('Download', lang)}</a>
                    </div>
                    : null
                }
            </div>
            <div className="post__body" dangerouslySetInnerHTML={{__html: content}} />
        </div>
    );
};

export default PostBody;
